import React, { useEffect, useState } from 'react'
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook'
import DesktopHeader from './DesktopHeader'

function Header({ className, containerClass, bgTransparent, sticky }) {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        isMobileViewHook(setIsMobile, 992)
    }, [])
    return isMobile ? <DesktopHeader /> : <DesktopHeader
        className={className}
        containerClass={containerClass}
        bgTransparent={bgTransparent}
        sticky={sticky}
    />
}

export default Header